import * as Yup from "yup";
import { getSchema } from "@twire/utility/helpers";
import { TFunction } from "i18next";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ForgotPasswordFormSchema = (t: TFunction) =>
  Yup.object().shape({
    username: getSchema(t).username,
  });

export const initialValues = {
  username: "",
};
